module.exports = __webpack_public_path__ + "img/no-data-by-freepik.4cc10335.png";